import { useMutation, useQuery } from "@tanstack/react-query";
import { boomProductsApi } from "api/boom-products/api";
import type { UpsellEventPayload } from "api/boom-products/types";

export const BOOM_PRODUCTS_QUERY_KEY = ["BOOM_PRODUCTS"];
export const BOOM_PRODUCT_ENABLE_MUTATION_KEY = [
  "BOOM_PRODUCT_ENABLE",
  "UPDATE"
];
export const BOOM_PRODUCT_REQUEST_MUTATION_KEY = [
  "BOOM_PRODUCT_REQUEST",
  "CREATE"
];

export const useBoomProducts = () =>
  useQuery({
    queryKey: BOOM_PRODUCTS_QUERY_KEY,
    queryFn: boomProductsApi.list,
    // Prices and status change rarely; mutations invalidate it explicitly.
    staleTime: 60_000
  });

/**
 * Fire-and-forget upsell analytics. Never blocks the UI and never surfaces an
 * error: a lost event is not worth interrupting the person for.
 */
export const useTrackUpsellEvent = () => {
  const { mutate } = useMutation({
    mutationKey: ["UPSELL_EVENT", "CREATE"],
    mutationFn: (payload: UpsellEventPayload) =>
      boomProductsApi.trackEvent(payload),
    onError: () => {
      // swallow: analytics must never affect the page
    }
  });

  return mutate;
};
